@if (loading()) {
  <div class="state-message">
    <qai-loading size="medium" />
  </div>
} @else if (loadError()) {
  <div class="state-message">
    {{ 'simulationBuilder.CALL_DETAILS_LOAD_ERROR' | transloco }}
  </div>
} @else if (details()) {
  <div class="generated-call-details-container">
    <generated-call-details
      [contentMarkdown]="details()!.contentMarkdown"
      [refinementStatus]="refinementStatus()"
      [isContentRefreshing]="isContentRefreshing()"
      [isRefinementBlocked]="isRefinementBlocked"
      (requestChangesSubmitted)="handleRequestChangesSubmitted($event)"
      (errorDismissed)="handleDismissRefinementError()"
    ></generated-call-details>
  </div>
}
